import { ref, readonly } from 'vue'

const toasts = ref([])
let toastId = 0

export function useToast() {
  function addToast({ title, message, variant = 'info', duration = 4000 }) {
    const id = ++toastId
    toasts.value.push({ id, title, message, variant })
    if (duration > 0) {
      setTimeout(() => removeToast(id), duration)
    }
    return id
  }

  function removeToast(id) {
    toasts.value = toasts.value.filter((t) => t.id !== id)
  }

  function success(title, message) {
    return addToast({ title, message, variant: 'success' })
  }

  function error(title, message) {
    return addToast({ title, message, variant: 'danger' })
  }

  function warning(title, message) {
    return addToast({ title, message, variant: 'warning' })
  }

  function info(title, message) {
    return addToast({ title, message, variant: 'info' })
  }

  return {
    toasts: readonly(toasts),
    addToast,
    removeToast,
    success,
    error,
    warning,
    info,
  }
}
